import { environmentConfig } from "@src/appV2/environment";
import { Worker } from "@src/appV2/Worker/api/types";
import { logApiFailureEvent } from "@src/lib/analytics";
import request from "superagent";

import { getAuthHeader } from "../../superagent";

export const updatePreference = async (
  preference: string,
  value: number | string,
  shouldThrowError = false
): Promise<Worker> => {
  return await request
    .post(`${environmentConfig.REACT_APP_BASE_API_URL}/agentProfile/preference`)
    .set(await getAuthHeader())
    .send({ key: preference, value: value })
    .then(({ body }) => body)
    .catch((err) => logApiFailureEvent(err, shouldThrowError));
};
